// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const psyduck: PokeData = {
  "id": 54,
  "name": "psyduck",
  "height": 8,
  "weight": 196,
  "base_experience": 64,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "tail-whip",
    "disable",
    "water-gun",
    "hydro-pump",
    "surf",
    "psybeam",
    "confusion",
    "hypnosis",
    "screech",
    "amnesia",
    "bubble",
    "fury-swipes",
    "psych-up",
    "water-sport",
    "water-pulse",
    "aqua-tail",
    "zen-headbutt",
    "wonder-room",
    "soak"
  ],
  "moves": [
    "scratch",
    "hydro-pump",
    "bubble",
    "aqua-tail",
    "zen-headbutt",
    "rain-dance",
    "aqua-cutter",
    "bubble-beam",
    "water-spout",
    "aqua-jet",
    "life-dew",
    "whirlpool",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 23,
    "item": null,
    "species": [
      {
        "name": "psyduck",
        "order": 59,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "golduck",
        "order": 60,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 54,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49.5,
    "speed": 55,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
